import { render, staticRenderFns } from "./POTransaction.vue?vue&type=template&id=65e9a84a"
import script from "./POTransaction.vue?vue&type=script&lang=js"
export * from "./POTransaction.vue?vue&type=script&lang=js"
import style0 from "./POTransaction.vue?vue&type=style&index=0&id=65e9a84a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports